import './App.css';
import './resources/css-custom-24-cols-grid/grid.css';
import './resources/js-simple-loader/loader.css';
import './resources/js-validation-notification/validation.style.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import React, { useEffect, useRef, useState } from 'react';
import { Service } from './service';
import { SimpleSection } from './components/simpleSection';
import target from './icons/icon_target.svg';
import Select from './components/select/select';
import { Title } from './components/title';
import { Calendario } from './components/calendar';
import { SimpleBadge } from './components/simpleBadge';
import { Modal } from './components/modal';
import { Button } from './components/button';
import { Input, InputCPF, InputEmail, InputTelefone } from './components/input';
import { Resultado } from './components/resultado';
import { Erro } from './components/erro';
import MapComponent from './components/map';
import StepMarker from './components/stepMarker';
import { faClock, faFlagCheckered, faIdCard, faMapLocationDot } from '@fortawesome/free-solid-svg-icons';
import { AppData, CardData, Location } from './types/types';
import CreditCardForm, { CreditCardRef } from './components/creditCard';
import { isValidCPF, isValidEmail, isValidTelefone } from './utils/validation';

type FormField = 'cpf' | 'telefone' | 'email';
type FormErrors = Partial<Record<FormField, string>>;

const validators: Record<FormField, (value: string) => string> = {
    cpf: (value) => {
        if (!value.trim()) return 'Informe o CPF.';
        return isValidCPF(value) ? '' : 'CPF inválido.';
    },
    telefone: (value) => {
        if (!value.trim()) return 'Informe o telefone.';
        return isValidTelefone(value) ? '' : 'Telefone inválido. Informe DDD + número.';
    },
    email: (value) => {
        if (!value.trim()) return 'Informe o e-mail.';
        return isValidEmail(value) ? '' : 'E-mail inválido.';
    },
};

function App() {
    const [operation, setOperation] = useState(0);
    // const [data, setData] = useState<AppData | null>({
    //     nome: 'Rodrigo Priolo',
    //     email: 'priolo@smartside.com.br',
    //     cpf: '33359250842',
    //     telefone: '11999999999',
    //     classificacao: null,
    //     classificao: null,
    //     unidade: null,
    //     modalidade: null,
    //     activity: null,
    //     hasWellhub: null,
    //     tokenGympass: null,
    //     user: null,
    //     userData: null,
    //     sucesso: null,
    //     idService: null,
    //     idMembership: null,
    //     payment: null,
    //     totalInstallments: null,
    //     cardData: null,
    //     sale: null,
    // });
    const [data, setData] = useState<AppData>({});
    const [branch, setBranch] = useState('');
    const [unidadeNome, setUnidadeNome] = useState('');
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [locations, setLocations] = useState<Location[]>([]);
    const [closestLocation, setClosestLocation] = useState<Location | null>(null);
    const [hasPermission, setHasPermission] = useState(false);
    const [source, setSource] = useState('');
    const [cardInstallments] = useState(1);
    const [formErrors, setFormErrors] = useState<FormErrors>({});
    const app = useRef<HTMLDivElement>(null);
    const creditCardRef = useRef<CreditCardRef>(null);

    window.addEventListener('resize', function () {
        setIsMobile(window.innerWidth < 768);
    });

    // useEffect(() => {
    //     // if (operation !== 5) {
    //     //     let test = Service.userHasSubmitted();
    //     //     if (test && test.email === data?.email && test.modalidade === data?.modalidade) {
    //     //         setData(test);
    //     //         setOperation(5);
    //     //     }
    //     // }
    //     // if (data.classificacao === 'Minha localização') {
    //     //     RequirePermission();
    //     // }
    // }, [data]);

    useEffect(() => {
        if (branch !== '') {
            Service.setBranch(branch);

            if (data?.unidade) {
                const unidades = Service.getLocations();
                if (unidades) {
                    let unidade = unidades.filter((unidade) => unidade.api === data.unidade)[0];
                    if (unidade) {
                        setUnidadeNome(unidade.nome);
                    }
                }
            }
        }
    }, [branch, data.unidade]);

    useEffect(() => {
        if (app.current) {
            if (isMobile) {
                app.current.style.minHeight = window.innerHeight - 700 + 'px';
            } else {
                app.current.removeAttribute('style');
            }
        }
    }, [isMobile]);

    useEffect(() => {
        if (operation >= 5) {
            if (app.current) {
                app.current.removeAttribute('style');
            }
        }
    }, [operation]);

    useEffect(() => {
        if (closestLocation !== null && hasPermission) {
            setBranch(closestLocation.api);
            setData((d) => ({ ...d, classificacao: closestLocation.regiao, unidade: closestLocation.api }));
            // isMobile e lido apenas na deteccao da localizacao; nao deve reexecutar em resize
            setOperation(isMobile ? 1 : 3);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [closestLocation, hasPermission]);

    const validateField = (field: FormField, value?: string): string => {
        const message = validators[field](value ?? '');
        setFormErrors((errors) => ({ ...errors, [field]: message }));
        return message;
    };

    const clearFieldError = (field: FormField) => {
        setFormErrors((errors) => (errors[field] ? { ...errors, [field]: '' } : errors));
    };

    const validateForm = (): boolean => {
        const errors: FormErrors = {};
        let valid = true;
        (Object.keys(validators) as FormField[]).forEach((field) => {
            const message = validators[field](data[field] ?? '');
            errors[field] = message;
            if (message) {
                valid = false;
            }
        });
        setFormErrors(errors);
        return valid;
    };

    const AddSale = async () => {
        if (!validateForm()) {
            return;
        }

        let cardData: CardData;
        try {
            const card = await creditCardRef.current!.tokenize();
            cardData = {
                token: card.token,
                temporaryToken: card.tokenTemporario,
                // O EVO usa o totalInstallments do cardData para pagamento tipo 1 (cartao de credito)
                totalInstallments: cardInstallments,
                truncatedCardNumber: card.ultimoDigitosCartao.replaceAll('*', ''),
                brand: card.bandeira,
                cardHolderName: card.nmIgualCartao,
                cardExpirationYear: Number(card.anoVencimento),
                cardExpirationMonth: Number(card.mesVencimento),
            };
        } catch (err) {
            console.error('Erro ao tokenizar cartão:', err);
            setOperation(6);
            return;
        }

        const saleData: AppData = { ...data, cardData, payment: 1, totalInstallments: cardInstallments };
        const result = await Service.addSale(saleData);
        if (!result) {
            setOperation(6);
            return;
        }
        window.dataLayer = window.dataLayer || [];
        if (source === 'tiktok') {
            window.dataLayer.push({ event: 'sign_up_locacao_tiktok', data: saleData });
        } else {
            window.dataLayer.push({ event: 'sign_up_locacao', data: saleData });
        }
        setOperation(5);
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const RequirePermission = () => {
        navigator.geolocation.getCurrentPosition(() => {
            setHasPermission(true);
        });
    };

    const SendToGTM = (e: React.FormEvent) => {
        e.preventDefault();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'generate_lead_calendar',
            data: data,
        });
        return false;
    };

    const Preselect = () => {
        setTimeout(function () {
            let params = Service.getParams();
            if (params) {
                const unidades = Service.getLocations();
                let unidade = unidades?.filter((unidade) => unidade.api === params[1])[0];
                setData({ ...data, classificacao: params[0], unidade: params[1], location: unidade || null });
                setBranch(params[1]);
                setClosestLocation(unidade || null);
                setOperation(unidade ? (isMobile ? 1 : 3) : 1);
            }
        }, 1000);
    };

    const Initialize = () => {
        const urlSource = Service.getSource();
        if (!!urlSource) {
            const hasSource = source !== '';
            if (!hasSource && urlSource === 'tiktok') {
                setSource(urlSource);
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'agendamento_tiktok_view',
                    data: data,
                });
            }
        }
    };

    useEffect(() => {
        Preselect();
        setTimeout(Preselect, 300);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        Initialize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        void Service.loadLocations().then(setLocations);
    }, []);

    return (
        <div
            className="App"
            ref={app}
        >
            <div className="app-hero">
                <div className="container">
                    <h1>Locação de quadra</h1>
                </div>
            </div>
            <div className={`app-content operation-${operation}`}>
                <div className="container">
                    <div id="step-markers">
                        <StepMarker
                            callback={() => setOperation(1)}
                            text="Unidade"
                            completed={operation > 0}
                            icon={faMapLocationDot}
                            current={operation <= 1}
                        />
                        <StepMarker
                            callback={operation >= 3 ? () => setOperation(3) : null}
                            text="Data"
                            completed={operation > 3}
                            icon={faClock}
                            current={operation === 3}
                        />
                        <StepMarker
                            callback={operation >= 4 ? () => setOperation(4) : null}
                            text="Cadastro"
                            completed={operation > 4}
                            icon={faIdCard}
                            current={operation === 4}
                        />
                        <StepMarker
                            text="Só colar!"
                            completed={operation === 5}
                            icon={faFlagCheckered}
                            current={operation === 5}
                        />
                    </div>
                </div>
                {operation < 5 && (
                    <>
                        <div className="container h-100">
                            {isMobile && operation > 1 && (
                                <button
                                    onClick={() => setOperation(operation - 1)}
                                    id="go-back"
                                >
                                    <i className="fas fa-chevron-left"></i>
                                </button>
                            )}

                            {(!isMobile || (isMobile && operation < 2)) && (
                                <div className="row d-flex">
                                    <div className="col-24 col-sm-24 col-md-9 col-lg-8">
                                        <div>
                                            <SimpleSection>
                                                <Title text={isMobile ? 'Locação de quadra' : 'Onde quer alugar a quadra?'} />
                                                <Select
                                                    placeholder="Selecione a Região"
                                                    name="classificacao"
                                                    value={data?.classificacao}
                                                    onChange={(e: string) => {
                                                        setData({ ...data, classificacao: e });
                                                        setOperation(operation < 1 ? 1 : operation);
                                                    }}
                                                    options={[
                                                        {
                                                            image: target,
                                                            value: 'Minha localização',
                                                            text: 'Minha localização',
                                                        },
                                                        ...Service.getRegions().map((regiao) => ({ value: regiao, text: regiao })),
                                                    ]}
                                                />
                                                {data?.classificacao && <SimpleBadge text={data?.classificacao} />}
                                                <br />
                                                {data?.classificacao && (
                                                    <Select
                                                        placeholder="Escolha a Unidade"
                                                        name="unidade"
                                                        value={data?.unidade}
                                                        onChange={(e: string) => {
                                                            setData({
                                                                ...data,
                                                                unidade: e,
                                                                location: locations.filter((location) => location.api === e)[0] || null,
                                                            });

                                                            if (!isMobile) {
                                                                setOperation(operation <= 2 ? 3 : operation);
                                                            }
                                                            setBranch(e);
                                                        }}
                                                        options={locations
                                                            .filter((unidade) => unidade.regiao === data.classificacao)
                                                            .map((unidade) => {
                                                                return { value: unidade.api, text: unidade.nome };
                                                            })}
                                                    />
                                                )}
                                                {unidadeNome !== '' && <SimpleBadge text={unidadeNome} />}
                                                <br />
                                                <br />
                                            </SimpleSection>
                                        </div>
                                    </div>
                                    <div className="col-24 col-sm-24 col-md-1 col-lg-2"></div>
                                    <div
                                        className="col-24 col-sm-24 col-md-14 col-lg-14"
                                        id="map"
                                    >
                                        {locations.length > 0 && (
                                            <MapComponent
                                                location={data.unidade}
                                                setClosestLocation={setClosestLocation}
                                                apiKey={Service.googleMapsAPIKey}
                                                establishmentAddresses={locations}
                                            />
                                        )}
                                        <div>
                                            <br />
                                            <br />
                                            <br />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {operation >= 3 && !!data?.unidade && (
                                <div className="row d-flex h-100">
                                    <div className="col-24">
                                        <br />
                                        <Calendario
                                            isMobile={isMobile}
                                            unidade={unidadeNome}
                                            modalidade={data?.modalidade}
                                            location={data?.location}
                                            onReturn={(activities) => {
                                                setData({ ...data, activities });
                                                setOperation(4);
                                            }}
                                        />
                                        <br />
                                        <br />
                                        <br />
                                        <br />
                                    </div>
                                </div>
                            )}
                        </div>

                        <Modal
                            open={operation === 4}
                            onClose={() => {
                                setOperation(operation - 1);
                            }}
                        >
                            <form onSubmit={SendToGTM}>
                                <input
                                    type="hidden"
                                    name="classificacao"
                                    value={data?.classificacao || ''}
                                />
                                <input
                                    type="hidden"
                                    name="unidade"
                                    value={data?.unidade || ''}
                                />
                                <input
                                    type="hidden"
                                    name="modalidade"
                                    value={data?.modalidade || ''}
                                />
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    <img
                                        src="http://posto011.com.br/wp-content/uploads/2022/12/android-chrome-144x144-1.png"
                                        className="img-responsive img-fluid pull-left float-left modal-image"
                                        alt="logo"
                                        style={{ marginRight: '10px' }}
                                    />
                                    <Title text={'Bora confirmar sua locação?'} />
                                </div>
                                {data?.location?.rental &&
                                    (() => {
                                        const rentalContract = Service.getRentalContract(data.location, data.activities?.length ?? 1);
                                        return (
                                            rentalContract && (
                                                <div className="rental-price-row">
                                                    <div className="rental-price-box rental-price-member">
                                                        <span className="rental-price-label">Alunos</span>
                                                        <span className="rental-price-value">{rentalContract.member.value}</span>
                                                    </div>
                                                    <div className="rental-price-box rental-price-not-member">
                                                        <span className="rental-price-label">Não alunos</span>
                                                        <span className="rental-price-value">{rentalContract.notMember.value}</span>
                                                    </div>
                                                </div>
                                            )
                                        );
                                    })()}
                                <span className="user-member">
                                    Preencha com o e-mail e documento cadastrados no Posto011 para verificarmos se você é aluno com plano ativo.
                                </span>
                                <Input
                                    placeholder={'Nome completo *'}
                                    value={data?.nome}
                                    onChange={(evt) => setData({ ...data, nome: evt.target.value })}
                                />
                                <InputCPF
                                    placeholder={'CPF *'}
                                    value={data?.cpf}
                                    error={formErrors.cpf}
                                    onChange={(evt) => {
                                        setData({ ...data, cpf: evt.target.value });
                                        clearFieldError('cpf');
                                    }}
                                    onBlur={(evt) => validateField('cpf', evt.target.value)}
                                />
                                <InputTelefone
                                    placeholder={'Telefone *'}
                                    value={data?.telefone}
                                    error={formErrors.telefone}
                                    onChange={(evt) => {
                                        setData({ ...data, telefone: evt.target.value });
                                        clearFieldError('telefone');
                                    }}
                                    onBlur={(evt) => validateField('telefone', evt.target.value)}
                                />
                                <InputEmail
                                    placeholder={'E-mail *'}
                                    value={data?.email}
                                    error={formErrors.email}
                                    onChange={(evt) => {
                                        setData({ ...data, email: evt.target.value });
                                        clearFieldError('email');
                                    }}
                                    onBlur={(evt) => validateField('email', evt.target.value)}
                                />
                                <br />
                                <strong>Dados do cartão de crédito</strong>
                                <CreditCardForm
                                    key={data?.unidade}
                                    ref={creditCardRef}
                                    branch={branch}
                                />
                                {/*{operation === 4 && }*/}
                                {/*<Select*/}
                                {/*    placeholder="Parcelas"*/}
                                {/*    name="installments"*/}
                                {/*    value={String(cardInstallments)}*/}
                                {/*    onChange={(e: string) => setCardInstallments(parseInt(e))}*/}
                                {/*    options={Array.from({ length: 12 }, (_, i) => ({*/}
                                {/*        value: String(i + 1),*/}
                                {/*        text: i === 0 ? '1x (à vista)' : `${i + 1}x`,*/}
                                {/*    }))}*/}
                                {/*/>*/}
                                <Button
                                    text="Continuar"
                                    onClick={AddSale}
                                />
                            </form>
                        </Modal>
                    </>
                )}

                {operation === 5 && (
                    <Resultado
                        isMobile={isMobile}
                        data={data}
                    />
                )}
                {operation === 6 && <Erro isMobile={isMobile} />}
            </div>
            {operation < 5 && !(isMobile && operation === 3) && (
                <div className={`footer-hero operation-${operation} d-none d-xs-block p-4`}>
                    <Button
                        text="Continuar"
                        enabled={
                            (operation === 1 && data.hasOwnProperty('classificacao') && data.hasOwnProperty('unidade')) ||
                            (operation === 2 && data.hasOwnProperty('modalidade')) ||
                            (operation === 3 && (data?.activities?.length ?? 0) > 0)
                        }
                        onClick={() => {
                            window.scrollTo(0, 0);
                            setOperation(operation === 1 ? operation + 2 : operation + 1);
                        }}
                    />
                </div>
            )}
        </div>
    );
}

export default App;
